<div class="flex flex-column gap-2">
  <ng-content/>
  @if (isLoading()) {
    <sens-loading />
  }
  <div #feedEndTarget></div>
</div>
